import React from 'react';
import PropTypes from 'prop-types';

// Components
import { Button, Tooltip } from '@beef/ui-kit';

const AddNumberButton = ({ isDisabled, tooltipText, onClick }) => {
  const button = (
    <Button
      size="m"
      type="button"
      variant="tertiary"
      disabled={isDisabled}
      onClick={onClick}
    >
      Добавить номер
    </Button>
  );

  if (isDisabled && tooltipText) {
    return (
      <Tooltip
        message={tooltipText}
        variant="secondary"
      >
        {button}
      </Tooltip>
    );
  }

  return button;
};

AddNumberButton.propTypes = {
  isDisabled: PropTypes.bool,
  tooltipText: PropTypes.string,
  onClick: PropTypes.func,
};

export { AddNumberButton };
